import { render, staticRenderFns } from "./OverlayAsset.vue?vue&type=template&id=f7e22780&"
import script from "./OverlayAsset.vue?vue&type=script&lang=js&"
export * from "./OverlayAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports